import * as React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import GuestUserNavToolsComponent from 'src/modules/commons/header/partials/GuestUserNavTools.component';
import LoggedUserNavToolsContainer from 'src/modules/commons/header/partials/LoggedUserNavTools.container';

interface Props {
  isLogged?: boolean;
  login: () => void;
  register: () => void;
}

const HeaderComponent = (props: Props) => {
  return (
    <header>
      <div className="sh">
        <div className="container">
          <div className="row">
            <div className="col-xs-2 col-sm-3">
              <div className="gap-5"/>
              <Link
                to="/"
                className="hidden-sm hidden-xs"
              >
                <img
                  src="/img/the-crowd-angel.png"
                  alt="logo"
                />
              </Link>
              <Link
                to="/"
                className="hidden-md hidden-lg logo-responsive"
              >
                <img
                  src="/img/the-crowd-angel-responsive.png"
                  alt="logo"
                />
              </Link>
            </div>
            <div className="col-xs-10 col-sm-9">
              <div className="gap-10"/>
              <nav className="navbar">
                <div className="navbar-header">
                  <button
                    type="button"
                    className="navbar-toggle collapsed"
                    data-toggle="collapse"
                    data-target="#bs-example-navbar-collapse-1"
                    aria-expanded="false"
                  >
                      <span className="sr-only">
                        Toggle navigation
                      </span>
                    <span className="icon-bar"/>
                    <span className="icon-bar"/>
                    <span className="icon-bar"/>
                  </button>
                </div>

                <div
                  className="collapse navbar-collapse"
                  id="bs-example-navbar-collapse-1"
                >
                  <ul className="nav navbar-nav navbar-right">
                    <li>
                      <Link
                        to="/muestrario-de-operaciones"
                        className="btn-menu border-left"
                      >
                        Invertir
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/como-financiar-tu-startup"
                        className="btn-menu border-left"
                      >
                        Emprendedores
                      </Link>
                    </li>
                    <li className="dropdown menu-more">
                      <a
                        className="dropdown-toggle btn-menu border-left border-right"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >Más
                        <span className="caret arrow-down-light"/>
                      </a>
                      <ul className="dropdown-menu">
                        <li>
                          <Link
                            to="/nuestro-equipo"
                            className="btn-menu"
                          >
                            Quiénes somos
                          </Link>
                        </li>
                        <li
                          role="separator"
                          className="divider"
                        />
                        <li>
                          <Link
                            to="/como-invertir"
                            className="btn-menu"
                          >
                            ¿Cómo invertir?
                          </Link>
                        </li>
                        <li
                          role="separator"
                          className="divider"
                        />
                        <li>
                          <Link
                            to="/muestrario-de-operaciones#portfolio"
                            className="btn-menu"
                          >
                            Portfolio
                          </Link>
                        </li>
                        <li
                          role="separator"
                          className="divider"
                        />
                        <li>
                          <a
                            className="btn-menu"
                            href="http://blog.thecrowdangel.com/"
                            target="_blank"
                          >
                            Nuestro Blog
                          </a>
                        </li>
                        <li
                          role="separator"
                          className="divider"
                        />
                        <li>
                          <Link
                            to="/contacto"
                            className="btn-menu"
                          >
                            Contacto
                          </Link>
                        </li>
                      </ul>
                    </li>
                    {
                      props.isLogged ?
                        <LoggedUserNavToolsContainer/> :
                        <GuestUserNavToolsComponent
                          login={props.login}
                          register={props.register}
                        />
                    }
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div className="gap-50"/>
      <div className="gap-50"/>
      <div className="menu-icon-res">
        <button
          type="button"
          className="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#bs-example-navbar-collapse-1"
          aria-expanded="false"
        >
            <span className="sr-only">
              Toggle navigation
            </span>
          <span className="icon-bar"/>
          <span className="icon-bar"/>
          <span className="icon-bar"/>
        </button>
      </div>
    </header>
  );
};

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/header/Header.component.tsx